// extracted by mini-css-extract-plugin
export var load8 = "index-module--load8--50964";
export var loader = "index-module--loader--6152d";